import React from 'react';
import { MdArrowForward } from 'react-icons/md';
import classNames from 'classnames';
import DynamicLink from '../DynamicLink';
import * as styles from './GlobalNav.module.styl';
import getHelpFileURL from '../../utils/getHelpFileURL';

function FeaturedItem({ featuredItem, isMobile = false }) {
  const { title, description, link, image } = featuredItem;
  if (!(title || description || image)) return null;

  return (
    <div
      className={classNames(
        styles.subMenuFeature,
        isMobile && styles.subMenuFeatureMobile,
      )}
    >
      {title ? <h3 className={styles.subMenuTitle}>{title}</h3> : null}
      {image ? (
        <img src={getHelpFileURL(image)} alt={description || ''} />
      ) : null}
      {description ? <p>{description}</p> : null}
      {link?.link_url && link?.link_text ? (
        <DynamicLink link={link.link_url}>
          {link.link_text} <MdArrowForward />
        </DynamicLink>
      ) : null}
    </div>
  );
}

export default FeaturedItem;
